import { createFileRoute } from '@tanstack/react-router'
import { useLocale } from 'react-intlayer'
import Body from '@/components/body'
import Heading from '@/components/heading'
import englishText from '@/components/md/en/interceptor_privacy_policy.md?raw'
import japaneseText from '@/components/md/ja/interceptor_privacy_policy.md?raw'
import ReactMarkdown from '@/components/react-markdown'

export const Route = createFileRoute('/term/interceptor_privacy_policy/')({
  component: Page
})

function Page() {
  const { locale } = useLocale()
  return (
    <>
      <Heading>
        <Heading.Title>
          {locale === 'en' ? 'Interceptor Privacy Policy' : 'Interceptor プライバシーポリシー'}
        </Heading.Title>
      </Heading>
      <Body className='max-w-3xl mx-auto'>
        <ReactMarkdown>{locale === 'en' ? englishText : japaneseText}</ReactMarkdown>
      </Body>
    </>
  )
}
